import { Base } from '@models/base.model';
import { PageObject } from '@testsigma/organism';
import { SKIP, custom, deserialize, optional, serializable } from 'serializr';
import { SalesforceAPIStepDataMap } from './salesforce-api-step-datamap.model';

export class SalesforceAPIStep extends Base implements PageObject {
  @serializable
  public salesforceObject: string;
  @serializable
  public stepId: number;
  @serializable
  public url: string;
  @serializable
  public salesforceObjectId: number;
  @serializable(
    optional(
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public salesforceAPIStepDatamap: SalesforceAPIStepDataMap[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceAPIStep, input));
  }
}
